var vertical_embed_viewer_default = {
  "card": "MuKIK",
  "slimLayout": "_1omQN",
  "cardLayout": "RWhUZ",
  "imageContainer": "HNQeP",
  "image": "oH5qT",
  "content": "N9PBE"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
